// return the correct editor-js/block editor block (component).
import { blocksBlockEditor } from '~/constants/blocks-block-editor'

export const useBlockEditorBlock = function (block: unknown): ComponentDefinition {
  if (blocksBlockEditor[block.type]) {
    return blocksBlockEditor[block.type]
  } else {
    throw new Error(`Block editor block ${block.type} not found.`)
  }
}
